import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
// import { Http } from '@angular/http';
// import "rxjs/add/operator/map";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { CampaignDashboardPage } from '../campaignDashboard/campaignDashboard';
import { AddCampaignPage } from '../addCampaign/addCampaign';

@Component({
  selector: 'page-campaignList',
  templateUrl: 'campaignList.html',
  // styleUrls: [ 'campaignList.scss', '../../theme/variables.scss' ]
})
export class CampaignListPage {
  public temples = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider) {
    this.temples = this.myApp.getTemples();
    console.log(this.temples);
    // this.getTemples();
    // console.log(this.temples);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TemplesListPage');
  }

  // getTemples(){
  //   this.govindaProvider.key = "get";
  //   console.log("http://localhost/TempleRoutes.php?key=" + this.govindaProvider.key);
  //   this.http.get("http://localhost/TempleRoutes.php?key=" + this.govindaProvider.key)
  //   .map(res => res.json())
  //   .subscribe(res => {
  //     this.temples = res.data; 
  //     console.log("Jason data: " + res.data);
  //     console.log("Temple Array : " + this.temples);
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }

  // deleteTemple(temple){
  //   this.govindaProvider.key = "delete";
  //   console.log("INCOWS : " + "http://localhost/TempleRoutes.php?temple_id=" + temple.ID + "&key=" + this.govindaProvider.key);
  //   this.http.get("http://localhost/TempleRoutes.php?temple_id=" + temple.ID + "&key=" + this.govindaProvider.key)
  //   .map(res => res)
  //   .subscribe(res => {
  //      alert("Deleted" + res);
  //      this.navCtrl.push(TemplesListPage);
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }

  // goToTempleDetailsPage(temple){
  //   this.navCtrl.push(TempleDetailsPage, {
  //     temple: temple
  //   })
  // }

  goToTempleDashboardPage(temple){
    // this.navCtrl.push(CampaignDashboardPage, {temple: temple});
  }

  goToAddTemplePage(){
    this.navCtrl.push(AddCampaignPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/campaigns/campaignList/campaignList.ts